import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { setApiErrorHandler } from 'configs/axios';
import { routes } from 'constants/routes';
import { ME_QUERY_KEY } from 'hooks/useMe';
import { signOutCompletely } from 'lib/signOut';

/**
 * axios のレスポンスエラー code を Router / QueryClient の世界へ橋渡しする。
 * BrowserRouter 配下で一度だけマウントする。
 */
export function ApiErrorWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    setApiErrorHandler({
      handleOrganizationSelectionError: (code) => {
        queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
        navigate(routes.SELECT_ORGANIZATION, {
          replace: true,
          // ORGANIZATION_REQUIRED は組織をまだ選んでいないだけで、選んだ組織が
          // 使えないわけではないため notAvailable は出さない
          state:
            code === 'ORGANIZATION_REQUIRED'
              ? undefined
              : { notAvailable: true },
        });
      },
      handleForcedSignOut: async (code) => {
        await signOutCompletely();
        navigate(routes.LOGIN, {
          replace: true,
          state: {
            // 再ログイン後に元の画面へ戻れるよう場所を残す
            from: `${location.pathname}${location.search}`,
            ...(code === 'ACCOUNT_PAUSED' ? { paused: true } : {}),
          },
        });
      },
    });
    return () => {
      setApiErrorHandler(null);
    };
  }, [location, navigate, queryClient]);

  return null;
}
